// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"4fc28ca5","903":"ca677670"}[chunkId] + ".chunk.js";
};